import React from "react";
import { useDictionary } from "hooks";
import SharedDropdown from "@cayuse/shared-react.components.dropdown";

/**
 * This is a pass-through wrapper which supplies the dictionary to the shared component
 */
const Dropdown = props => {
	const dictionary = useDictionary("common.dropdown");

	return <SharedDropdown dictionary={dictionary} {...props} />;
};

Object.assign(Dropdown, { ...SharedDropdown }); /* copy remaining properties */

export default Dropdown;
